const DOMAINS = 'domain';

const isDomainsEnabled = (flags = {}) => {
  return flags[DOMAINS];
};

module.exports = {
  isDomainsEnabled
};
